import type { RouteObject } from "react-router-dom";
import { page } from "@/app/page";
import { RequireSuperAdmin, RequireTenantAdmin } from "@/app/guards";

export const adminRoutes: RouteObject[] = [
  { id: "admin.customers", path: "/customers", element: page(() => import("@/screens/Customers")) },
  { id: "admin.portal-preview", path: "/portal-preview", element: <RequireSuperAdmin>{page(() => import("@/screens/CustomerPortal"))}</RequireSuperAdmin> },
  { id: "admin.org", path: "/admin", element: <RequireTenantAdmin>{page(() => import("@/screens/Admin"))}</RequireTenantAdmin> },
  { id: "admin.imports", path: "/admin/imports", element: <RequireTenantAdmin>{page(() => import("@/screens/Imports"))}</RequireTenantAdmin> },
  { id: "admin.org.tab", path: "/admin/:tab", element: <RequireTenantAdmin>{page(() => import("@/screens/Admin"))}</RequireTenantAdmin> },
  { id: "admin.pricing", path: "/pricing", element: page(() => import("@/screens/Pricing")) },
  { id: "admin.system", path: "/system", element: <RequireSuperAdmin>{page(() => import("@/screens/DesignSystem"))}</RequireSuperAdmin> },
  {
    path: "/super",
    element: page(() => import("@/screens/superadmin/Layout")),
    children: [
      { id: "super.overview", index: true, element: page(() => import("@/screens/superadmin/Overview")) },
      { id: "super.tenants", path: "tenants", element: page(() => import("@/screens/superadmin/Tenants")) },
      { id: "super.plans", path: "plans", element: page(() => import("@/screens/superadmin/Plans")) },
      { id: "super.users", path: "users", element: page(() => import("@/screens/superadmin/Users")) },
      { id: "super.impersonate", path: "impersonate", element: page(() => import("@/screens/superadmin/Impersonate")) },
      { id: "super.templates", path: "templates", element: page(() => import("@/screens/superadmin/EmailTemplates")) },
      { id: "super.settings", path: "settings", element: page(() => import("@/screens/superadmin/PlatformSettings")) },
      { id: "super.roles", path: "roles", element: page(() => import("@/screens/superadmin/Roles")) },
      { id: "super.ra-sections", path: "ra-sections", element: page(() => import("@/screens/superadmin/RaSections")) },
      { id: "super.usage", path: "usage", element: page(() => import("@/screens/superadmin/Usage")) },
    ],
  },
];
